import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceStatus = ({ 
  serviceName, 
  status, 
  lastSync, 
  onConfigure, 
  onTest,
  className = '' 
}) => {
  const getStatusColor = () => {
    switch (status) {
      case 'connected': return 'text-success';
      case 'error': return 'text-error';
      case 'warning': return 'text-warning';
      default: return 'text-text-secondary';
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'connected': return 'CheckCircle';
      case 'error': return 'XCircle';
      case 'warning': return 'AlertTriangle';
      default: return 'Circle';
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'connected': return 'Connected';
      case 'error': return 'Connection Error';
      case 'warning': return 'Limited Access';
      default: return 'Not Configured';
    }
  };

  return (
    <div className={`flex items-center justify-between p-4 bg-muted rounded-lg ${className}`}>
      <div className="flex items-center space-x-3">
        <div className="flex items-center space-x-2">
          <Icon 
            name={getStatusIcon()} 
            size={16} 
            className={getStatusColor()} 
          />
          <span className="font-medium text-text-primary">{serviceName}</span>
        </div>
        <div className="text-sm text-text-secondary">
          {getStatusText()}
          {lastSync && status === 'connected' && (
            <span className="ml-2">• Last sync: {lastSync}</span>
          )}
        </div>
      </div>
      
      <div className="flex items-center space-x-2">
        {onTest && status === 'connected' && (
          <Button
            variant="outline"
            size="sm"
            onClick={onTest}
            iconName="Send"
            iconPosition="left"
          >
            Test
          </Button>
        )}
        <Button
          variant={status === 'connected' ? 'outline' : 'default'}
          size="sm"
          onClick={onConfigure}
          iconName="Settings"
          iconPosition="left"
        >
          {status === 'connected' ? 'Configure' : 'Setup'}
        </Button>
      </div>
    </div>
  );
};

export default ServiceStatus;